import { all, fork } from 'redux-saga/effects';
import { watchCreateMemberSaga } from './create-member';
import { watchGetMembers } from './get';
import { watchGetProjectMembers } from './get-project-members';
import { watchInviteMembersSaga } from './invite-members';
import { watchDeactivateMemberSaga, watchReactivateMemberSaga } from './member-management';
import { watchResendMemberInvitationSaga } from './resend-invite';
import { watchUpdateMembersSaga } from './update-member';
export const membersRootSaga = function*() {
    yield all([
        fork(watchGetProjectMembers),
        fork(watchGetMembers),
        fork(watchCreateMemberSaga),
        fork(watchDeactivateMemberSaga),
        fork(watchReactivateMemberSaga),
        fork(watchInviteMembersSaga),
        fork(watchResendMemberInvitationSaga),
        fork(watchUpdateMembersSaga)
    ]);
};
